import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { ProductTuitionDaysNumberInput } from '../../../lib/types/models/product/product-tuition-days-number-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<ProductTuitionDaysNumberInput> & {
  className?: string
}

const formSchema: ZodType<ProductTuitionDaysNumberInput> = z.object({
  durationInDays: createNumberSchema('nombre de jours', {
    errorMessage: 'Le nombre de jours doit être un entier valide'
  }),
  from: createNumberSchema('de', {
    errorMessage: 'Veuillez entrer une valeur de début valide'
  }),
  to: createNumberSchema('à', {
    errorMessage: 'Veuillez entrer une valeur de fin valide'
  })
})

const ProductTuitionDaysNumberForm = ({
  defaultValues,
  className,
  ...validationButtonProps
}: Props) => {
  const form = useForm<ProductTuitionDaysNumberInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className={cn('flex flex-col gap-4', className)}
      >
        <FormField
          control={form.control}
          name={'durationInDays'}
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} type="number" label="# de jours de cours" />
              </FormControl>
            </FormItem>
          )}
        />
        <div className="flex gap-4">
          <FormField
            control={form.control}
            name={'from'}
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="number" label="De" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name={'to'}
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="number" label="À" />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default ProductTuitionDaysNumberForm
